"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const ListAddButton = ({ color, mouseDownColor, onClick, text }) => (React.createElement("div", { style: {
        width: 145,
        height: 24,
        display: 'flex',
        alignItems: 'center',
    }, onClick: onClick },
    React.createElement("div", { style: {
            width: 24,
            height: 24,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: color ? color : src_1.turquoise,
            marginRight: 8,
            marginLeft: 14,
        } },
        React.createElement(src_1.PlusIcon, { fill: src_1.white })),
    React.createElement(src_1.Button, { text: text, mouseDownColors: {
            active: color ? color : src_1.turquoise,
            inactive: mouseDownColor ? mouseDownColor : src_1.aquamarine,
        }, type: "regular", style: {
            innerStyle: {
                pointerEvents: 'none',
            },
            outerStyle: {
                pointerEvents: 'none',
            },
        } })));
exports.default = React.memo(ListAddButton);
